module.exports = __webpack_public_path__ + "static/media/puzzle0201.131fb3ce.jpg";